import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  *{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  html{
    font-size: 62.5%;
    background: #ffffff;
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
  }
`;
